import { render } from "./ui-minute-selector.vue?vue&type=template&id=759bf5da&ts=true"
import script from "./ui-minute-selector.vue?vue&type=script&lang=ts"
export * from "./ui-minute-selector.vue?vue&type=script&lang=ts"

import "./ui-minute-selector.vue?vue&type=style&index=0&id=759bf5da&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__